// "ITS 60% · Harrisburg 40%" from an artifact SKU row's `warehouse_allocation`
// (or the product totals'). Empty string when the forecast wasn't split.
export const warehouseSplitLabel = (allocation) =>
  (allocation || [])
    .filter((a) => Number(a.pct) > 0)
    .map((a) => `${a.name || "Warehouse"} ${Math.round(Number(a.pct) * 100)}%`)
    .join(" · ");

// Why an active warehouse was left out of the split.
export const SKIPPED_WAREHOUSE_REASON = {
  no_valid_postal: "no zip code on file",
  no_zone_chart: "no shipping-zone chart for its zip",
};

export const skippedWarehousesText = (skipped) =>
  (skipped || [])
    .map(
      (s) =>
        `${s.name || "a warehouse"} (${SKIPPED_WAREHOUSE_REASON[s.reason] || s.reason})`,
    )
    .join(", ");

// Whether any SKU in an artifact carries a warehouse split — older artifacts
// don't, so the column is left out rather than shown empty.
export const hasWarehouseSplit = (skus) =>
  (skus || []).some((s) => (s.warehouse_allocation || []).length > 0);
